import { render } from "./step5.vue?vue&type=template&id=4a977edb&scoped=true"
import script from "./step5.vue?vue&type=script&lang=ts"
export * from "./step5.vue?vue&type=script&lang=ts"

import "./step5.vue?vue&type=style&index=0&id=4a977edb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a977edb"

export default script